<template>
	<div class="mb-4">
		<v-card class="mb-3"
			color="grey lighten-1"
			justify-center>
			<br>

			<div class="text-xs-center mt-3 mb-3">
				<h2>Podaj dane osobowe</h2>
			</div>

			<v-container grid-list-md text-xs-center>
				<v-layout row wrap justify-center>

					<v-flex xs3>
					</v-flex>
					<v-flex xs6>
						<v-text-field
							browser-autocomplete="given-name"
							data-vv-name="name"
							data-vv-as="Imię"
							:error-messages="vErrors.collect('scope1.name')"
							label="Imię *"
							aria-label="label for name"
							for="step-personal-data-component-name"
							id="step-personal-data-component-name"
							v-model="stepData.name"
							v-validate="'required'"
							data-vv-scope="scope1">
						</v-text-field>
					</v-flex>
					<v-flex xs3>
					</v-flex>

					<v-flex xs3>
					</v-flex>
					<v-flex xs6>
						<v-text-field
							browser-autocomplete="family-name"
							data-vv-name="surname"
							data-vv-as="Nazwisko"
							:error-messages="vErrors.collect('scope1.surname')"
							label="Nazwisko *"
							aria-label="label for surname"
							for="step-personal-data-component-surname"
							id="step-personal-data-component-surname"
							v-model="stepData.surname"
							v-validate="'required'"
							data-vv-scope="scope1">
						</v-text-field>
					</v-flex>
					<v-flex xs3>
					</v-flex>

					<v-flex xs3>
					</v-flex>
					<v-flex xs6>
						<v-text-field
							browser-autocomplete="email"
							data-vv-name="email"
							data-vv-as="E-mail"
							:error-messages="vErrors.collect('scope1.email')"
							label="E-mail *"
							aria-label="label for email"
							for="step-personal-data-component-email"
							id="step-personal-data-component-email"
							v-model="stepData.email"
							v-validate="'required|email'"
							data-vv-validate-on="none"
							data-vv-scope="scope1">
						</v-text-field>
					</v-flex>
					<v-flex xs3>
					</v-flex>

					<div class="text-xs-center">
						<v-container fluid>
							<v-checkbox v-model="isAdult" v-bind:label="text1"
								browser-autocomplete="off"
								aria-label="checkbox for being adult"
								id="step-personal-data-component-is-adult"
								for="step-personal-data-component-is-adult"></v-checkbox>
							<v-checkbox v-model="hasCitizenship" v-bind:label="text2"
								browser-autocomplete="off"
								aria-label="checkbox for having citizenship"
								id="step-personal-data-component-has-citizenship"
								for="step-personal-data-component-has-citizenship"></v-checkbox>
						</v-container>
					</div>

				</v-layout>
			</v-container>

		</v-card>
		<v-btn to="/home" color="blue">Anuluj</v-btn>
		<v-btn v-if="isAdult === false || hasCitizenship === false"
			disabled
			color="primary">
			Dalej
		</v-btn>
		<v-btn v-else
			color="primary"
			@click="$emit('step', 2, 'scope1')">
			Dalej
		</v-btn>
	</div>
</template>

<script>
	export default {
		name: "StepPersonalDataComponent",
		inject: ["parentValidator"],

		created() {
			this.$validator = this.parentValidator;
		},

		data() {
			return {
				isAdult: false,

				hasCitizenship: false,

				text1: "Jestem osobą pełnoletnią *",

				text2: "Posiadam obywatelstwo polskie *",
			};
		},

		props: {
			stepData: Object,
		},
	};
</script>

<style scoped>
	.theme--dark .theme--dark.v-btn.v-btn--disabled:not(.v-btn--icon):not(.v-btn--flat):not(.v-btn--outline) {
		background-color: #0052A5 !important;
	}
</style>
